const state = {
  'usuario': ''
}

const getters = {
  usuario: state => {
    return state.usuario;
  }
}

const mutations = {
  setUsuario (state, value) {
    state.usuario = value;
  }
}

const actions = {
  setUsuario (context, value) {
    context.commit('setUsuario', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/usuario.js